<template>
  <v-list class="notice-list" flat>
    <v-list-item-group v-for="(item, i) in searchList" :key="i">
      <v-list-item @click="$emit('selectItem', item.postId)">
        <v-list-item-content>
          <v-list-item-title
            v-text="item.title"
            class="notice-title"
          ></v-list-item-title>
          <v-list-item-subtitle>
            <span v-text="item.createDate" class="date"></span>
            <span v-text="item.createUserName" class="divider writer"></span>
            <span class="divider cnt"
              ><v-icon color="#cacdcf" size="15">mdi-eye</v-icon
              >{{ item.viewCnt }}</span
            >
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <v-icon color="#9ca3ab">mdi-chevron-right</v-icon>
        </v-list-item-icon>
      </v-list-item>

      <v-divider
        inset
        class="list-divider-line"
        v-show="searchList.length > i + 1"
      ></v-divider>
    </v-list-item-group>
  </v-list>
</template>

<script>
/* 게시글리스트 컴포넌트 */

export default {
  props: {
    searchList: { type: [] },
  },
};
</script>

<style></style>
